<template>
<div class="product-module__tabbed">
    <div class="tabs">
        <ul>
            <li v-for="tab, i in tabs" :class="{'is-active': tab.active}"><a @click.prevent="tab_clicked(i)">{{tab.title}}</a></li>
        </ul>
    </div>
    <div class="product-module__tabbed-contents">
        <div :class="['product-module__tabbed-content product-description', {'show': shown_tab == 0}]">
            <div class="content" v-html="site_data.content"></div>
        </div>
        <div :class="['product-module__tabbed-content product-details', {'show': shown_tab == 1}]">
            <div class="content">
                <p v-if="site_data.brand"><router-link :title="site_data.brand.title" :to="site_data.brand.url"><img :alt="site_data.brand.title + '\'s logo'" :src="site_data.brand.logo.url" /></router-link></p>
                <p><strong>SKU</strong> {{site_data.sku}}</p>
                <p><strong>In stock</strong> {{site_data.stock}} item{{site_data.stock > 1 ? 's' : ''}}</p>
            </div>
        </div>
        <div :class="['product-module__tabbed-content product-attachments', {'show': shown_tab == 2}]">
            <ul v-if="site_data.attachments && site_data.attachments.length > 0">
                <li v-for="item in site_data.attachments">
                    <a :title="item.title" :href="item.url" target="_blank">
                        <i v-if="item.ext == 'pdf'" class="far fa-file-pdf"></i><i v-else class="far fa-file-word"></i> <span>{{item.title}}</span>
                    </a>
                </li>
            </ul>
            <div class="content" v-else>
                <p>No manual provided</p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name    :   'ProductContentTabs',
    data()
    {
        return {
            tabs        :   [
                {
                    title   :   'Description',
                    active  :   true
                },
                {
                    title   :   'Product Details',
                    active  :   false
                },
                {
                    title   :   'Product Manuals',
                    active  :   false
                },
            ],
            shown_tab   :   0
        };
    },
    computed    :   {
        site_data()
        {
            return this.$store.state.site_data;
        }
    },
    methods     :   {
        tab_clicked(i)
        {
            this.tabs.forEach( o => {
                o.active    =   false;
            });

            this.tabs[i].active =   true;
            this.shown_tab      =   i;
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/elements/ProductContentTabs.vue